import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import ReactQuill from 'react-quill';

interface Props {
  name: string;
  control: Control<any>;
  label?: string;
  placeholder?: string;
  helperText?: string | null;
}

export default function RichTextInput({ name, control, label, helperText = null, placeholder = '' }: Props) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const editorHeight = isLargeScreen ? 220 : 180;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=''
      render={({ field, fieldState: { error } }) => (
        <Box>
          {label && (
            <Typography mb={1} fontWeight={500}>
              {label}
            </Typography>
          )}

          <Box
            sx={{
              border: '1px solid',
              borderColor: error ? 'error.main' : '#ececec',
              borderRadius: 1,
              '& .ql-toolbar': {
                borderColor: '#ececec',
                borderRadius: '4px 4px 0 0'
              },
              '& .ql-container': {
                borderColor: '#ececec',
                borderRadius: '0 0 4px 4px',
                minHeight: editorHeight
              }
            }}
          >
            <ReactQuill
              theme='snow'
              value={field.value || ''}
              placeholder={placeholder}
              onChange={field.onChange}
              modules={{
                toolbar: [
                  ['bold', 'italic', 'underline'],
                  [{ list: 'ordered' }, { list: 'bullet' }],
                  ['link'],
                  ['clean']
                ]
              }}
            />
          </Box>

          {(error || helperText) && (
            <Typography
              variant='caption'
              color={error ? 'error.main' : 'text.secondary'}
              sx={{ mt: 0.5, display: 'block' }}
            >
              {error ? error.message : helperText}
            </Typography>
          )}
        </Box>
      )}
    />
  );
}
